import React from "react";
import {getSyncEngineVersion} from "../../../common/helpers/syncEngine";
import SetupV1 from "../SetupV1";
import SetupV2 from "../SetupV2";

/**
 * Version router only. New registration/onboarding is V2.
 * SetupV1 is frozen for rare legacy re-setup.
 */
const Setup: React.FC = () => {
    return getSyncEngineVersion() === 'v2' ? <SetupV2 /> : <SetupV1 />;
};

export default Setup;
